import {
  siteLanguageDetailsFragment,
  siteLanguageFragment
} from "@saleor/fragments/siteLanguages";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { TypedQuery } from "../queries";
import {
  SiteLanguageDetails,
  SiteLanguageDetailsVariables
} from "./types/SiteLanguageDetails";
import {
  SiteLanguageList,
  SiteLanguageListVariables
} from "./types/SiteLanguageList";

const siteLanguageList = gql`
  ${siteLanguageFragment}
  query SiteLanguageList(
    $first: Int
    $after: String
    $last: Int
    $before: String
  ) {
    siteLanguages(before: $before, after: $after, first: $first, last: $last) {
      totalCount
      edges {
        node {
          ...SiteLanguageFragment
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
    }
  }
`;
export const useSiteLanguageListQuery = makeQuery<
  SiteLanguageList,
  SiteLanguageListVariables
>(siteLanguageList);

const siteLanguageDetails = gql`
  ${siteLanguageDetailsFragment}
  query SiteLanguageDetails($id: ID!) {
    siteLanguage(id: $id) {
      ...SiteLanguageDetailsFragment
    }
  }
`;
export const TypedSiteLanguageDetailsQuery = TypedQuery<
  SiteLanguageDetails,
  SiteLanguageDetailsVariables
>(siteLanguageDetails);
